import { render, staticRenderFns } from "./StackedPopupNotification.vue?vue&type=template&id=7cc8dfbc&scoped=true"
import script from "./StackedPopupNotification.vue?vue&type=script&lang=js"
export * from "./StackedPopupNotification.vue?vue&type=script&lang=js"
import style0 from "./StackedPopupNotification.vue?vue&type=style&index=0&id=7cc8dfbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc8dfbc",
  null
  
)

export default component.exports